<template>
  <div
    class="landing-page__product-categories"
    :style="`background-image: url(${
      backgroundImage || ''
    });background-repeat:no-repeat;background-size: cover`"
  >
    <div class="title">
      {{ section.title }}
      <div v-if="section.description" class="description">
        {{ section.description }}
      </div>
    </div>
    <div class="categories" :class="`categories-collumns-${itemCollumns}`" v-if="section.categories?.length">
      <div
        class="categorie"
        :class="`categorie__${categoriesTitlePosition}`"
        v-for="(item, index) of section.categories"
        :key="index"
      >
        <sib-link :to="item.link" :title="item.title">
          <img :src="item.image" :alt="item.title" loading="lazy" />
          <div class="categorie__title" :class="`categorie__title--${categoriesTitlePosition}`">
            {{ item.title }}
          </div>
        </sib-link>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import useDeviceStore from '@/store/device'
const deviceStore = useDeviceStore()

const props = withDefaults(defineProps<{ section: any }>(), {})

const backgroundImage = computed(() => {
  return deviceStore.isMobile
    ? props.section?.backgroundImageMobile
    : props.section?.backgroundImageDesktop
})

const itemCollumns = computed(() => {
  return props.section?.itemColumns || 3
})

const categoriesTitlePosition = computed(() => {
  return props.section?.titlePosition || 'below'
})
</script>

<style lang="scss">
.landing-page__product-categories {
  padding-top: 1rem;
  padding-bottom: 1rem;
  @include media-md-up() {
    padding-top: 0;
    padding-bottom: 1rem;
  }
  .title {
    font-size: 23px;
    font-weight: bold;
    text-align: center;
    margin: 2rem 0;
    @include media-md-up {
      font-size: 26px;
    }
  }
  .description{
    font-size: 14px;
    font-weight: 400;
     @include media-md-up {
      font-size: 16px;
    }
  }
  .categories-collumns-2 {
    grid-template-columns: 1fr !important;
    .categorie__title {
        font-size: 20px !important;
      }
  }
  @include media-md-up() {
    .categories-collumns-2 {
      grid-template-columns: 1fr 1fr !important;
      .categorie__title {
        font-size: 24px !important;
      }
    }

    .categories-collumns-5 {
      grid-template-columns: 1fr 1fr 1fr 1fr 1fr !important;
      .categorie__title {
        font-size: 16px !important;  
      }
    }
  }
  .categories {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 1rem;
    padding-bottom: 1rem;
    text-align: center;
    @include media-md-up() {
      margin: auto;
      gap: 20px;
      grid-template-columns: 1fr 1fr 1fr;
    }
    .categorie {
      border-radius: 10px;
      background: white;
      box-shadow: rgba(0, 0, 0, .25) 1px 3px 4px;
      position: relative;
    }
    .categorie__inside {
      line-height: 0;
      img {
        border-radius: 10px;
      }
    }
    .categorie__title {
      font-weight: 500;
      font-size: 16px;
      padding-top: 3px;
      padding-bottom: 10px;
      @include media-md-up() {
        font-size: 22px;
      }
    }
    .categorie__title--inside {
      width: max-content;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      bottom: 1rem;
      color: #ffffff;
      @include media-md-up() {
        bottom: 1.5rem;
      }
     
    }
    img {
      border-radius: 10px 10px 0 0;
    }
    a {
      text-decoration: none;
    }
  }
}
</style>
